import { Button, Chip, Grid, Typography } from "@material-ui/core"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import AppContext from "~/contexts/App"

import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import useStyles from "./styles"

const AccessLink = ({ accessLink, client }) => {
  //provided is an object used to move the lessons inside courses
  const classes = useStyles()
  const { openDialog } = useContext(AppContext)

  const openEditAccessLink = () => {
    let data = {
      accessLink: accessLink,
      client: client,
      action: "edit",
    }
    openDialog("createEditAccessLink", data)
  }
  return (
    <PaperListRow componentWidth={"100%"}>
      <Grid container spacing={0} className={classes.container}>
        <Grid
          item
          md={3}
          xs={6}
          className={classes.titleContainer}
          // onClick={() => history.push(`/lessons/${lesson.lesson_id}`)}
        >
          <HoverText
            data={accessLink?.code}
            size={30}
            variant="h3"
            className={classes.nameText}
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={6}
          className={classes.titleContainer}
          // onClick={() => history.push(`/lessons/${lesson.lesson_id}`)}
        >
          <Typography>{`${accessLink?.uses}/${accessLink?.seats}`}</Typography>
        </Grid>
        <Grid item md={2} xs={6} className={classes.titleContainer}>
          <Typography>
            {dayjs(accessLink?.expiration)?.format("M/D/YYYY")}
          </Typography>
        </Grid>
        <Grid item md={2} xs={6} className={classes.titleContainer}>
          <Chip
            label={accessLink?.is_active ? "Active" : "Inactive"}
            classes={
              accessLink?.is_active
                ? { root: classes.greenChip }
                : { root: classes.redChip }
            }
            style={{ minWidth: "50px" }}
          />
        </Grid>
        <Grid item md={2} xs={12} className={classes.titleContainer}>
          <PermissionsWrapper permissionGroup="admin">
            <Button onClick={openEditAccessLink}>Edit</Button>
          </PermissionsWrapper>
        </Grid>
      </Grid>
    </PaperListRow>
  )
}

AccessLink.propTypes = {
  accessLink: PropTypes.object,
  client: PropTypes.object,
  provided: PropTypes.object,
}

export default AccessLink
